import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextBoxComponent } from '../components/text-box.component';
import { OnlyNumber } from 'src/core/directives/only-number.directive';
import { OnlyNumberModule } from 'src/core/directives/only-number.module';
import { EmptyStringValidator } from 'src/projects/registration/src/app/models/emptyStringValidator ';

@NgModule({
  declarations: [
    EmptyStringValidator,
      TextBoxComponent
  ],
  imports:[
    CommonModule,
    FormsModule,
    OnlyNumberModule

  ],
  exports:[
    EmptyStringValidator,
      TextBoxComponent
  ]
})
export class TextBoxModule { }
